import { i as r } from "./isArrayLike.js";
import { i as e } from "./isObjectLike.js";
var s = r, t = e;
function a(i) {
  return t(i) && s(i);
}
var L = a;
export {
  L as i
};
//# sourceMappingURL=isArrayLikeObject.js.map
